import React, { ReactNode } from 'react'

import * as S from './ConditionalQuestions.styles'

export const ConditionalQuestions = ({ children }: { children: ReactNode | ReactNode[] }) => <S.Root>{children}</S.Root>
